<template>
  <v-app>
    <v-layout row justify-center>
      <v-dialog
        v-model="isLoading"
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
          class="d-flex justify-center align-center"
        >
          <v-card-text>
            {{ $t("loading") }}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
    <router-view />
  </v-app>
</template>

<script>
import Lottie from "vue-lottie";
import loading from "@/assets/animation/loading.json";

export default {
  name: "App",
  components: {
    Lottie
  },
  data() {
    return {
      lottieOptions: { animationData: loading }
    };
  },
  computed: {
    isLoading() {
      // window.scrollTo(0, 0);
      return this.$store.getters.isLoading;
    }
  },
  mounted() {
    this.$store.commit("isLoading", true);
    setTimeout(() => {
      this.$store.commit("isLoading", false);
    }, 1000);
  }
};
</script>
